import { APP_ACTIVITY_MAX_SPAN_MS, type AppActivityInterval } from "@excalidraw-ms/shared";

export class AppActivityCollector {
  private interval: AppActivityInterval | null = null;
  private timer: ReturnType<typeof setTimeout> | undefined;

  constructor(private readonly send: (interval: AppActivityInterval) => void) {}

  record(now = Date.now()): void {
    const timestamp = new Date(now).toISOString();
    if (
      this.interval &&
      (now < Date.parse(this.interval.lastOccurredAt) ||
        now - Date.parse(this.interval.firstOccurredAt) >= APP_ACTIVITY_MAX_SPAN_MS ||
        timestamp.slice(0, 10) !== this.interval.firstOccurredAt.slice(0, 10))
    )
      this.flush();
    if (!this.interval) {
      this.interval = {
        eventId: crypto.randomUUID(),
        firstOccurredAt: timestamp,
        lastOccurredAt: timestamp,
      };
      this.timer = setTimeout(() => this.flush(), APP_ACTIVITY_MAX_SPAN_MS);
    } else {
      this.interval.lastOccurredAt = timestamp;
    }
  }

  flush(): void {
    if (this.timer) clearTimeout(this.timer);
    this.timer = undefined;
    const interval = this.interval;
    this.interval = null;
    if (interval) this.send(interval);
  }

  discard(): void {
    if (this.timer) clearTimeout(this.timer);
    this.timer = undefined;
    this.interval = null;
  }
}

export function isAppUsageInput(event: Event): boolean {
  if (!event.isTrusted || !(event.target instanceof Element)) return false;
  if (event.target.closest("[data-app-usage-exclude]")) return false;
  if (
    !event.target.closest(
      [
        '[data-app-usage-surface="writing"]',
        '[data-app-usage-surface="sharing"]',
        '[data-app-usage-surface="management"]',
        '[data-app-usage-surface="reading"]',
        '[data-app-usage-surface="feedback"]',
        '[data-app-usage-surface="import-export"]',
        ".excalidraw .excalidraw__canvas",
        ".excalidraw .ToolIcon",
      ].join(", "),
    )
  )
    return false;
  if (event instanceof KeyboardEvent && ["Shift", "Control", "Alt", "Meta"].includes(event.key))
    return false;
  if (event instanceof PointerEvent && event.type === "pointermove" && event.buttons === 0)
    return false;
  return true;
}
